import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const AllDayCheckbox = (props) => {
  const { checked, onChange } = props;
  return (
    <FormControlLabel
      value="end"
      control={
        <Checkbox
          color="primary"
          checked={checked}
          onChange={onChange}
          name="allDayEvent"
        />
      }
      label="All day event"
      labelPlacement="end"
    />
  );
};

export default AllDayCheckbox;
